import { HoverCard, HoverCardContent, HoverCardTrigger } from '@/components/ui/hover-card.js';
import { ReactNode, useRef, useState, type Ref } from 'react';

interface TooltipProps {
  trigger: ReactNode;
  children: ReactNode;
  contentClassName?: string;
  /** When true, `trigger` is the focusable control. It must be a single element such as a button. */
  asChild?: boolean;
}

export const Tooltip = ({ trigger, children, contentClassName, asChild = false }: TooltipProps) => {
  const [open, setOpen] = useState(false);
  const triggerRef = useRef<HTMLElement>(null);

  return (
    <HoverCard open={open} onOpenChange={setOpen} openDelay={0}>
      <HoverCardTrigger
        ref={triggerRef as Ref<HTMLAnchorElement>}
        asChild={asChild}
        onClick={() => setOpen((prev) => !prev)}
        className="cursor-pointer group/tooltip"
      >
        {trigger}
      </HoverCardTrigger>
      <HoverCardContent
        className={contentClassName}
        onPointerDownOutside={(event) => {
          const target = event.detail.originalEvent.target as Node | null;
          if (target && triggerRef.current?.contains(target)) {
            event.preventDefault();
          }
        }}
      >
        {children}
      </HoverCardContent>
    </HoverCard>
  );
};
